import React, { ReactNode } from 'react';
import axios, { AxiosInstance } from 'axios';

import { DrinkUpServiceApiContext } from './DrinkUpServiceApiContext';

// API Service Client
const LOCAL_API_SERVICE_URL: string = "http://localhost:8000";
const PRODUCTION_API_SERVICE_URL: string = "https://young-cliffs-57944.herokuapp.com";

const baseURL: string = window.location.hostname === "localhost" ? LOCAL_API_SERVICE_URL : PRODUCTION_API_SERVICE_URL;
const client: AxiosInstance = axios.create({
    baseURL
});

interface DrinkUpServiceApiProviderProps {
    children: ReactNode;
}

function DrinkUpServiceApiProvider({ children }: DrinkUpServiceApiProviderProps): JSX.Element {
    return (
        <DrinkUpServiceApiContext.Provider value={{ drinkUpService: client }}>
            {children}
        </DrinkUpServiceApiContext.Provider>
    );
}

export { DrinkUpServiceApiProvider };
